/**
 * saas 请求响应 & 签名验签 SDK
 * 签名依赖 sha256 算法
 * npm install js-sha256
 *
 * @author litao
 */

import mfe88 from '@/utils/mfe88'
import sha256 from 'js-sha256'

const Request = function(host, service, api, trace, param) {
  this.host = host
  this.service = service
  this.api = api
  this.trace = trace
  this.param = param
}

const Response = function(code, message, system, trace, data) {
  this.code = code
  this.message = message
  this.system = system
  this.trace = trace
  this.data = data
}

const SIGN_SALT_0 = 'mfhcd'
const SIGN_SALT_1 = 'saas'
const SIGN_PARAMETER = ['host', 'service', 'api']

/**
 * 签名算法
 * @param request Object 请求对象
 * @returns {string|null} 签名 Sign
 */
const sign = function(request) {
  if (request === null || typeof request === 'undefined') {
    return null
  }
  const rk = Object.keys(request).sort(function(a, b) {
    return a > b ? 1 : a < b ? -1 : 0
  })
  const kv = []
  rk.forEach(function(value) {
    if (SIGN_PARAMETER.indexOf(value) >= 0) {
      const o = {}
      o.key = value
      o.value = request[value]
      kv.push(o)
    }
  })
  const keyValue = []
  kv.forEach(function(item) {
    const s = item.key + '=' + item.value
    keyValue.push(s)
  })
  let string = ''
  string += SIGN_SALT_0
  keyValue.forEach(function(item) {
    string += '&' + item
  })
  string += '&' + SIGN_SALT_1
  return sha256.sha256(string)
}

const verify = function(s, response) {
  return sign(response) === s
}

/**
 * Request 对象构造方法
 * @param service service 编码
 * @param api API 编码
 * @param param 业务参数
 * @returns {Request}
 */
function data(service, api, param) {
  const host = '0.0.0.0' // 本机 host
  return new saas.Request(host, service, api, null, param)
}

/**
 * 用于穿过网关的 Http Header
 * @param request 请求对象
 * @returns {{Time: *, Sign: *, "Content-Type": string}}
 */
function header(request) {
  const xUserAction = request.xUserAction ? encodeURI(request.xUserAction) : encodeURI(request.api)
  if (request.xUserAction) {
    delete request.xUserAction
  }
  return {
    'Time': new Date().toUTCString(),
    'Sign': saas.sign(request),
    'Content-Type': 'application/json; charset=UTF-8',
    'X-Service': request.service,
    'X-Api': request.api,
    'X-User-Action': xUserAction
  }
}

/**
 * 用于穿过网关的上传 Http Header

 * @returns {{Time: *}}
 */
function headerUpload() {
  return {
    'Time': new Date().toUTCString()
  }
}

/**
 * 用于穿过网关的下载 Http Header
 * @param request 请求对象
 * @returns {{Time: *, Sign: *, "Content-Type": string}}
 */
function headerDownload(request) {
  return {
    'Time': new Date().toUTCString(),
    'Sign': saas.sign(request),
    'Content-Type': 'application/octet-stream'
  }
}

/**
 * 服务名称
 * @returns {{SAAS_API: string, FILE_API: string, DICT_API: string}}
 * @constructor
 */
const ServiceName = {
  SAAS_API: 'saas-api',
  FILE_API: 'file-api',
  DICT_API: 'dict-api',
  OAUTH2_API: 'oauth2-api',
  USER_API: 'user-api',
  CUSTOMER_API: 'customer-api',
  ORDER_API: 'order-api',
  TERMINAL_API: 'terminal-api'
}

/**
 * 常量
 * @returns {{GATEWAY: string}}
 * @constructor
 */
const Constant = {
  // GATEWAY_URL: 'https://' + process.env.VUE_APP_SAAS_GATEWAY_HOST
  GATEWAY_URL: mfe88.apiUrl
}

/**
 * saas
 * @type {{Response: *, SaasConstant: *, data: *, headerUpload: *, ServiceName: *, Request: *, sign: *, verify: *, header: *, headerDownload: *}}
 */
const saas = {
  Request,
  Response,
  sign,
  verify,
  data,
  header,
  headerUpload,
  headerDownload,
  ServiceName,
  Constant
}

export default saas
